import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { equipmentUrls } from "../../../URL/ApplicationUrls";
import { Equipment } from "../Equipment";
import { sortArrayBy } from "../../../Utils/arrays";

export const useFetchEquipment = () => {
  return useQuery<Equipment[], Error>({
    queryKey: "bid",
    queryFn: () => fetchEquipment(),
    onError: () => toast.error("An error occurred while retrieving the equipment"),
  });
};

const fetchEquipment = async () => {
  const { data: equipment } = await axios.get<Equipment[]>(equipmentUrls.base.apiUrl);

  sortArrayBy({
    values: equipment,
    keyToSort: "Name",
  });

  return equipment;
};
